var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBlood = function SvgBlood(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.05 9.817-3.683-7.109A1.548 1.548 0 0 0 10 1.875c-.575 0-1.1.317-1.367.833L4.95 9.817a5.64 5.64 0 0 0 .192 5.575 5.659 5.659 0 0 0 4.866 2.733 5.659 5.659 0 0 0 4.867-2.733 5.662 5.662 0 0 0 .192-5.575h-.017Zm-1.258 4.925A4.422 4.422 0 0 1 10 16.875c-1.558 0-2.983-.8-3.792-2.133a4.425 4.425 0 0 1-.15-4.35l3.684-7.109c.05-.1.15-.158.258-.158.108 0 .208.058.258.158l3.684 7.109a4.404 4.404 0 0 1-.15 4.35Zm-3.475.358a.63.63 0 0 1-.625.625c-1.075 0-2.05-.55-2.609-1.467a3.02 3.02 0 0 1-.1-2.991.622.622 0 0 1 .842-.267.622.622 0 0 1 .267.842 1.803 1.803 0 0 0 1.6 2.633.63.63 0 0 1 .625.625Z",
    fill: "current"
  })));
};
export default SvgBlood;